import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    open: PropTypes.bool,
    className: PropTypes.string,
};

const BurgerIcon = ({ open = false, className = null }) => (
    <svg
        width="62"
        height="17.5"
        viewBox="0 0 62 17.5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        {open ? (
            <>
                <path
                    fill="none"
                    strokeLinecap="round"
                    strokeWidth="2px"
                    stroke="url(#gradient_1)"
                    d="M2,16.5L60,1"
                />
                <path
                    fill="none"
                    strokeLinecap="round"
                    strokeWidth="2px"
                    stroke="url(#gradient_2)"
                    d="M2,1l58,15.5"
                />
            </>
        ) : (
            <>
                <path
                    fill="none"
                    strokeLinecap="round"
                    strokeWidth="2px"
                    stroke="url(#gradient_a1)"
                    d="M1,3.8h60"
                />
                <path
                    fill="none"
                    strokeLinecap="round"
                    strokeWidth="2px"
                    stroke="url(#gradient_a2)"
                    d="M1,8.8h60"
                />
                <path
                    fill="none"
                    strokeLinecap="round"
                    strokeWidth="2px"
                    stroke="url(#gradient_a3)"
                    d="M1,13.8h60"
                />
            </>
        )}
        <defs>
            <linearGradient
                id="gradient_1"
                data-name="Dégradé sans nom"
                x1="2"
                y1="3"
                x2="60"
                y2="18.5"
                gradientTransform="translate(0 19.5) scale(1 -1)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#b7ced6" />
                <stop offset="1" stopColor="#007dff" />
            </linearGradient>
            <linearGradient
                id="gradient_2"
                data-name="Dégradé sans nom 2"
                x1="2"
                y1="18.5"
                x2="60"
                y2="3"
                gradientTransform="translate(0 19.5) scale(1 -1)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#b7ced6" />
                <stop offset="1" stopColor="#007dff" />
            </linearGradient>
            <linearGradient
                id="gradient_a1"
                data-name="Dégradé sans nom"
                x1="1"
                y1="15.8"
                x2="61"
                y2="15.8"
                xlinkHref="#gradient_1"
            />
            <linearGradient
                id="gradient_a2"
                data-name="Dégradé sans nom"
                x1="1"
                y1="10.8"
                x2="61"
                y2="10.8"
                xlinkHref="#gradient_1"
            />
            <linearGradient
                id="gradient_a3"
                data-name="Dégradé sans nom"
                x1="1"
                y1="5.8"
                x2="61"
                y2="5.8"
                xlinkHref="#gradient_1"
            />
        </defs>
    </svg>
);

BurgerIcon.propTypes = propTypes;

export default BurgerIcon;
